import { createGlobalStyle } from 'styled-components';
const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Roboto',Helvetica,Arial,sans-serif;
  }
`;

export default GlobalStyle;
